import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CasRHFSwitch } from 'src/compass/shared/components';

export default function EmployeeFlagFields() {
  const triggerFields = ['isRiskManager', 'isBusDev'];
  const { control, trigger } = useFormContext();
  const [isRiskManager, isBusDev] = useWatch({ control, name: triggerFields });

  useEffect(() => {
    if (!isRiskManager && isBusDev !== undefined) trigger(triggerFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRiskManager, isBusDev, trigger]);

  return (
    <>
      <CasRHFSwitch name="isRiskManager" label="Is Risk Manager?" />
      <CasRHFSwitch name="isBusDev" label="Is Bus Dev?" />
    </>
  );
}
